module.exports = __webpack_public_path__ + "static/media/message-promotion-season.c2be4f79.png";